import React from 'react'

import Text from '../../../../../components/pdf/Text'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Separator from '../../../../../components/pdf/Separator'
import { useReplies, useServiceOrder } from '../../_load/ServiceOrderLoader'
import {
  findReplyByQuestionId,
  formatDollar,
  formatEnglishShortDate,
  getReplyValue,
  sumAmount
} from '../../_helpers/pdfHelpers'

const PaymentSummary = ({ hardwareData, softwareData, servicesData }) => {
  const serviceOrder = useServiceOrder()
  const replies = useReplies()

  const date = serviceOrder?.endDate
  const subtotal = getReplyValue(findReplyByQuestionId(replies, 339))
  const tax = getReplyValue(findReplyByQuestionId(replies, 339))
  const total = getReplyValue(findReplyByQuestionId(replies, 339))

  return (
    <>
      <Text bold size="h5">
        Payment Summary
      </Text>
      <Separator weight={5} />
      <Table width="100%" fixedLayout useFontBaseColor>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Date</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Subtotal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Tax</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Total</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text>{formatEnglishShortDate(date)}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>{formatDollar(sumAmount([...hardwareData, ...softwareData, ...servicesData], 'subtotal'))}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>{formatDollar(sumAmount([...hardwareData, ...softwareData, ...servicesData], 'tax'))}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>{formatDollar(sumAmount([...hardwareData, ...softwareData, ...servicesData], 'total'))}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Total</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{subtotal}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{tax}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{total}</Text>
          </TableCol>
        </TableRow>
      </Table>
    </>
  )
}

export default PaymentSummary
